export default "8812c07182d74618.woff"